// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { plumeTestnet as _plumeTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the plumeTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 161221135
 * Chain Name: Plume Testnet
 * Default Block Explorer: https://testnet-explorer.plumenetwork.xyz
 * Default RPC URL: https://testnet-rpc.plumenetwork.xyz/http
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { plumeTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: plumeTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const plumeTestnet = createCommon({
	..._plumeTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
